export default __webpack_public_path__ + "static/N0285-a87f9d3fb5a6f46e61f63fb5afd52095.png";